import React from 'react';
import { Buffer } from 'buffer'
window.Buffer = Buffer
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'prismjs/prism';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import '@fullcalendar/common/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';
import '@fullcalendar/timeline/main.css';
import 'src/assets/css/main.css';
import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import App from 'src/App';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'src/queryClient';
import './utils/datadog';

enableES5();
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <QueryClientProvider client={queryClient}>
        <SettingsProvider>
            <App />
        </SettingsProvider>
    </QueryClientProvider>
);

serviceWorker.register();
